import { asyncInitializedMixpanel } from './asyncMixpanel';

export enum MixpanelUserField {
  Network = 'network',
  NetworkId = 'networkId',
  IsAcastEmail = 'isAcastEmail',
  AuthRole = 'authRole',
}

/**
 * Update a field in the currently identified user's profile.
 *
 * See:
 * https://docs.mixpanel.com/docs/tracking-methods/sdks/javascript#storing-user-profiles
 */
async function updateMixpanelUser(key: MixpanelUserField, value: string | boolean): Promise<void> {
  const mixpanel = await asyncInitializedMixpanel;
  mixpanel.people.set(key, value);
}

export async function identifyMixpanelUser(userId: string): Promise<void> {
  const mixpanel = await asyncInitializedMixpanel;
  mixpanel.identify(userId);
}

export function updateMixpanelUserNetwork(networkId: string, networkName: string): void {
  updateMixpanelUser(MixpanelUserField.NetworkId, networkId);
  updateMixpanelUser(MixpanelUserField.Network, networkName);
}

export function updateMixpanelUserIsAcastEmail(): void {
  updateMixpanelUser(MixpanelUserField.IsAcastEmail, true);
}

export function updateMixpanelUserAuthRole(role: string): void {
  updateMixpanelUser(MixpanelUserField.AuthRole, role);
}